<script setup>
import {useVuelidate} from '@vuelidate/core'
import {required, email, sameAs} from '@vuelidate/validators'
import {reactive} from '../../../node_modules/vue/dist/vue.esm-bundler';
import {ref, onMounted} from "vue";

const props = defineProps({
  formtype: String
})

const state = reactive({
  emailSent: false,
  alternateSubject: '',
  isPrivacyChecked: false,
  form: {
    salutation: '',
    firstname: '',
    lastname: '',
    email: '',
    message: '',
  }
});

const contactForm = ref(null);

const rules = {
  isPrivacyChecked: {required, sameAs: sameAs(true), $autoDirty: true},
  form: {
    salutation: {required, $autoDirty: true},
    firstname: {required, $autoDirty: true},
    lastname: {required, $autoDirty: true},
    email: {required, email, $autoDirty: true},
    message: {required, $autoDirty: true},
  }
};

const v$ = useVuelidate(rules, state)

const submit = () => {
  v$.value.$touch();

  const formData = new FormData(contactForm.value);
  formData.append('formtype', props.formtype);

  if (v$.value.$errors.length === 0) {
    fetch('/form-submit', {
      body: formData,
      method: 'POST'
    }).then(response => {
      state.emailSent = true;
      console.log(response);
    }).catch(error => {
      state.emailSent = true;
      console.log(error);
    });
  }
}

</script>

<template>
  <div class="columns " v-if="!state.emailSent">
    <div class="column is-8 text-flow">
      <h2 class="heading-2">Ihr Anliegen</h2>
    </div>
  </div>
  <form action="" class="text-flow" ref="contactForm" v-if="!state.emailSent">
    <div class="box">
      <div class="columns is-multiline">

        <div class="column is-9">
          <div class="field is-horizontal">
            <div class="field-body">
              <div class="control">
                <label class="radio">
                  <input type="radio" name="salutation" value="herr" v-model="state.form.salutation" @blur="v$.form.salutation.$touch">
                  Herr
                </label>
                <label class="radio">
                  <input type="radio" name="salutation" value="frau" v-model="state.form.salutation" @blur="v$.form.salutation.$touch">
                  Frau
                </label>
              </div>
            </div>
          </div>
          <div role="alert" aria-live="assertive">
            <p v-if="v$.form.salutation.$errors.length > 0" class="help is-danger">Bitte überprüfen Sie Ihre Eingabe.</p>
          </div>

          <div class="field has-floating-label" :class="{ 'is-active': state.form.firstname.length > 0 }">
            <label for="form.firstname" class="label">Vorname</label>
            <div class="control">
              <input id="form.firstname" class="input" :class="{ 'is-danger' : v$.form.firstname.$errors.length > 0 }" type="text" name="firstname" placeholder="Vorname *"
                     v-model="state.form.firstname" @blur="v$.form.firstname.$touch">
            </div>
            <div role="alert" aria-live="assertive">
                <p v-if="v$.form.firstname.$errors.length > 0" class="help is-danger"><i class="fas fa-warning" role="presentation"></i> Bitte überprüfen Sie Ihre Eingabe.</p>
            </div>
          </div>

          <div class="field has-floating-label" :class="{ 'is-active': state.form.lastname.length > 0 }">
            <label for="form.lastname" class="label">Nachname *</label>
            <div class="control">
              <input id="form.lastname" class="input" :class="{ 'is-danger' : v$.form.lastname.$errors.length > 0 }" type="text" name="lastname" placeholder="Nachname *"
                     v-model="state.form.lastname"  @blur="v$.form.lastname.$touch">
            </div>
            <div role="alert" aria-live="assertive">
                <p v-if="v$.form.lastname.$errors.length > 0" class="help is-danger"><i class="fas fa-warning" role="presentation"></i> Bitte überprüfen Sie Ihre Eingabe.</p>
            </div>
          </div>

          <div class="field has-floating-label" :class="{ 'is-active': state.form.email.length > 0 }">
            <label for="form.email" class="label">E-Mail *</label>
            <div class="control">
              <input id="form.email" class="input" :class="{ 'is-danger' : v$.form.email.$errors.length > 0 }" type="email" name="email" placeholder="E-Mail *"
                     v-model="state.form.email" @blur="v$.form.email.$touch">
            </div>
            <div role="alert" aria-live="assertive">
                <p v-if="v$.form.email.$errors.length > 0" class="help is-danger"><i class="fas fa-warning" role="presentation"></i> Bitte überprüfen Sie Ihre Eingabe.</p>
            </div>
          </div>

          <div class="field has-floating-label" :class="{ 'is-active': state.form.message.length > 0 }">
            <label for="form.message" class="label">Ihre Anfrage *</label>
            <div class="control">
                  <textarea id="form.message" name="message" cols="40" rows="10" class="input" placeholder="Ihre Anfrage *"
                            v-model="state.form.message" :class="{ 'is-danger' : v$.form.message.$errors.length > 0 }"  @blur="v$.form.message.$touch"></textarea>
            <div role="alert" aria-live="assertive">
              <p v-if="v$.form.message.$errors.length > 0" class="help is-danger"><i class="fas fa-warning" role="presentation"></i> Bitte überprüfen Sie Ihre Eingabe.</p>
            </div>
            </div>
          </div>

          <div class="field mt-5">
            <div class="control">
              <label class="checkbox">
                <input type="checkbox" name="attach-file" v-model="state.isPrivacyChecked">
                Ich habe die <a href="/datenschutzinformationen">Datenschutzinformation</a> zur Kenntnis genommen.
              </label>
            </div>
            <div role="alert" aria-live="assertive">
                <p v-if="v$.isPrivacyChecked.$errors.length > 0" class="help is-danger">Bitte überprüfen Sie Ihre Eingabe.</p>
            </div>
          </div>

          <div class="mt-5 mb-5">
            <p><i class="far fa-lightbulb"></i> <strong>Hinweis</strong>: Die Übertragung der Daten an uns erfolgt in
              verschlüsselter Form.
              Dennoch möchten wir Sie bitten, uns keine zusätzlichen persönlichen Daten mit Ihrer Anfrage zu
              übermitteln.</p>
          </div>

          <div class="buttons is-left mt-6">
            <a @click.prevent="submit" class="button is-primary js-accessible-click" tabindex="0">Absenden</a>
          </div>

          <p class="mt-6">Darüber hinaus möchten wir Sie an dieser Stelle noch auf die für unser Haus zuständige Aufsichtsbehörde hinweisen:</p>
          <p class="mt-4">Bundesanstalt für Finanzdienstleistungsaufsicht<br>Marie-Curie-Str. 24-28<br>60439 Frankfurt</p>
        </div>
      </div>
    </div>
  </form>
  <div v-else>
    <div class="columns">
      <div class="column text-flow">
        <h2 class="heading-2">Vielen Dank</h2>
        <p>Ihre Nachricht ist bei uns eingegangen und wird von uns schnellstmöglich bearbeitet. Üblicherweise erhalten Sie innerhalb von zwei Werktagen Rückmeldung. Bitte beachten Sie, dass Anfragen, die uns am Wochenende oder an Feiertagen erreichen, eine entsprechend längere Bearbeitungszeit aufweisen.</p>
        <p><strong>Hinweis:</strong> In der aktuellen Lage kann es immer noch zu einer erhöhten Anzahl von Anfragen im Kundenservice kommen. Daher bitten wir um Verständnis, falls unsere Rückmeldung Sie nicht innerhalb der üblichen Fristen erreicht.</p>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
